module.exports = __webpack_public_path__ + "static/hu-tao-banner-0be61e2c6438a63b029df4679f077b3d.png";